import request from '@/utils/request'
// /**
//  * SystemDictQuery
//  */
// export interface ApifoxModel {
//   /**
//    * 字典来源
//    */
//   source: Source;
//   /**
//    * 字典类型集合
//    */
//   typeList: string[];
//   [property: string]: any;
// }

// /**
// * 字典来源
// */
// export enum Source {
//   Custom = "CUSTOM",
//   System = "SYSTEM",
// }
// 查询字典数据列表
export function getDictData(data) {
  return request({
    url: '/power/system/dict/list',
    method: 'post',
    data,
  })
}
